'use client';

import { c as _c } from "react/compiler-runtime";
import type { WebMainPageResponse } from '@module/apis/client-side/main/type';
import SettingConfig from '@module/config/setting';
import getMainListAdjustSize from '@pc/utils/main/getMainListAdjustSize';
import Link from 'next/link';
import MainBroadcastSection, { type MainSectionProps } from './MainBroadcastSection';
interface Props extends MainSectionProps {
  data?: WebMainPageResponse;
}
function LivePlusDescription() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="flex items-center gap-[10px] text-[18px]"><span className="text-[#777]">최상의 시청 경험을 위해 시차가 없는 라이브 기술을 적용한 LIVE+ 방송입니다.</span><Link href="/customer/notice/5172497" className="font-bold text-[#777] hover:underline">[자세히보기]</Link></p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function LivePlusContainer(t0) {
  const $ = _c(11);
  const {
    data,
    isLoading,
    isFetching,
    isFetched,
    currentScreenSize,
    listLength
  } = t0;
  let t1;
  if ($[0] !== currentScreenSize || $[1] !== data || $[2] !== listLength) {
    t1 = data?.realtime ? getMainListAdjustSize({
      list: data.realtime,
      currentScreenSize,
      listLength
    }) ?? [] : undefined;
    $[0] = currentScreenSize;
    $[1] = data;
    $[2] = listLength;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const bjList = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LivePlusDescription />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== bjList || $[6] !== isFetched || $[7] !== isFetching || $[8] !== isLoading || $[9] !== listLength) {
    t3 = <MainBroadcastSection dataTestId="main-live-plus" title={"\uC2DC\uCC28 \uC5C6\uB294 LIVE+ \uBC29\uC1A1"} icon={`${SettingConfig.S3_BUCKET_URL}/img/icon/bolt_mb.svg`} list={bjList} isLoading={isLoading} isFetching={isFetching} isFetched={isFetched} listLength={listLength} description={t2} />;
    $[5] = bjList;
    $[6] = isFetched;
    $[7] = isFetching;
    $[8] = isLoading;
    $[9] = listLength;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
export default LivePlusContainer;